import router from './router'
import store from './store'
import { Loading, Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/common/auth' // get token from cookie
import getPageTitle from '@/common/get-page-title'
import _ from 'lodash'
import { resetRouter } from './router'
// import Layout from '@/layout/index'
import { localRoutes,page404 } from './router'
// import getters from "@/store/getters";

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar
  // eslint-disable-next-line no-unreachable
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    const include = to.meta.include
    const pPath = to.meta.pPath
    const path = to.path
    if (include && pPath) {
      const routerData = store.getters.allRouter.find(m => {
        return m === pPath
      })
      if (include.length === 1 ) {
        if (routerData.power.indexOf(include[0]) === -1) {
          Message.error('暂无权限！请联系管理员')
          return
        }
      }
      if (include.length === 2 ) {
        if (routerData.power.indexOf(include[0]) === -1 && routerData.power.indexOf(include[1]) === -1) {
          Message.error('暂无权限！请联系管理员')
          return
        }
      }
    }
    if (path === '/recipe/recipeList' || path === '/recipe/recipeDispense' || path === '/recipe/recipeDecoct' || path === '/recipe/recipePost'){

      const routerDatas = store.getters.allRouter.find(m => {
        return m === path
      })
      if (routerDatas) {
        window.sessionStorage.setItem('powerData',JSON.stringify(routerDatas.power))
      }
    }


    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      const noUserInfo = _.isEmpty(store.getters.userInfo)
      // if (hasRoles) {
      if (!noUserInfo) {
        next()
      } else {
        const loadingInstance1 = Loading.service({ fullscreen: true, text: '正在更新基础数据' })
        try {
          const { data } = await store.dispatch('user/getInfo')
          if (_.isEmpty(data)) {
            // eslint-disable-next-line no-prototype-builtins
            throw new Error('获取用户数据失败')
          }
          await store.dispatch('store/getStoreList', data.store)
          store.dispatch('user/organization') // 存储机构信息
          let accessRoutes = [];
          if(data.type==1){
            accessRoutes = await store.dispatch('permission/generateRoutes', data.permissions)
          }else{
            accessRoutes = await store.dispatch('permission/generateRoutes', data.store[0].permissions)
          }
          // await store.dispatch('store/getStoreList', data.funcList)
          // store.dispatch('user/organization') // 存储机构信息
          // const accessRoutes = await store.dispatch('permission/generateRoutes', data.funcList[0].func)
          resetRouter()
          router.addRoutes(accessRoutes)
          router.addRoutes(localRoutes)
          router.addRoutes(page404)

          loadingInstance1.close()
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || '登录失败,请重新登录！')
          next(`/login?redirect=${to.path}`)
          loadingInstance1.close()
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})
router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
